import { BASE_API_PATH } from 'src/utils/constants';

export const zerreactorBackendEndpoints = {
  // Auth
  //----------------------------------------------------------------------
  Admin: {
    setPaymentsDeferred: `${BASE_API_PATH}/Admin/SetPaymentsDeferred`,
    userNotificationReceipents: `${BASE_API_PATH}/Admin/UserNotificationReceipents`,
    participantNotificationReceipents: `${BASE_API_PATH}/Admin/ParticipantNotificationReceipents`,
  },

  // Tour Reservation
  //----------------------------------------------------------------------
  TourReservation: {
    Create: `${BASE_API_PATH}/TourReservation/Create`,
    Get: (id) => `${BASE_API_PATH}/TourReservation/Get?Id=${id}`,
    GetAll: `${BASE_API_PATH}/TourReservation/GetAll`,
    GetByFinalistId: (id) => `${BASE_API_PATH}/TourReservation/GetByFinalistId?FinalistId=${id}`,
    GetAvailableFinalists: (finalistId) => `${BASE_API_PATH}/TourReservation/GetAvailableFinalists`,
    Approve: (id) => `${BASE_API_PATH}/TourReservation/Approve?TourReservationId=${id}`,
    Reject: (id) => `${BASE_API_PATH}/TourReservation/Reject?TourReservationId=${id}`,
  },

  Fix: {
    getParticipantsBirthday: `${BASE_API_PATH}/Fix/GetParticipantsBirthday`,
    setParticipantBirthday: `${BASE_API_PATH}/Fix/SetParticipantBirthday`,
    getPassportDates: `${BASE_API_PATH}/Fix/GetPassportDates`,
    setPassportDates: `${BASE_API_PATH}/Fix/SetPassportDates`,
  },

  Auth: {
    version: `${BASE_API_PATH}/Auth/Version`,
    login: `${BASE_API_PATH}/Auth/Login`,
    refreshTokens: `${BASE_API_PATH}/Auth/RefreshTokens`,
    changeOrganization: (organizationId) =>
      `${BASE_API_PATH}/Auth/ChangeOrganization?OrganizationId=${organizationId}`,
    confirmEmail: `${BASE_API_PATH}/Auth/ConfirmEmail`,
    signUpUser: `${BASE_API_PATH}/Auth/SignUpUser`,
    sendResetPasswordEmail: `${BASE_API_PATH}/Auth/SendResetPasswordEmail`,
    forgetPassword: `${BASE_API_PATH}/Auth/ForgetPassword`,
    resetPassword: `${BASE_API_PATH}/Auth/ResetPassword`,
    VirtualLogin: `${BASE_API_PATH}/Auth/VirtualLogin`,
    initiatePassword: `${BASE_API_PATH}/Auth/InitiatePassword`,
    sendVerificationEmail: `${BASE_API_PATH}/Auth/SendVerificationEmail`,
    profile: `${BASE_API_PATH}/Auth/Profile`,
    updateProfileInformations: `${BASE_API_PATH}/Auth/UpdateProfileInformations`,
    updateProfileJudgeDetails: `${BASE_API_PATH}/Auth/UpdateProfileJudgeDetails`,
    requestEmailUpdate: `${BASE_API_PATH}/Auth/RequestEmailUpdate`,
    updateSelfEmail: `${BASE_API_PATH}/Auth/UpdateSelfEmail`,
    profilePicture: `${BASE_API_PATH}/Auth/ProfilePicture`,
    updatePassword: `${BASE_API_PATH}/Auth/UpdatePassword`,
    scheduleEvents: (startDate, endDate) =>
      `${BASE_API_PATH}/Auth/ScheduleEvents?StartDate=${startDate}&EndDate=${endDate}`,
    feedbacks: `${BASE_API_PATH}/Auth/Feedbacks`,
    updateSelectedCompetitionId: (competitionId) =>
      `${BASE_API_PATH}/Auth/UpdateSelectedCompetitionId?CompetitionId=${competitionId}`,
  },

  // Competition
  //----------------------------------------------------------------------
  Competition: {
    Create: `${BASE_API_PATH}/Competition/Create`,
    Get: (id) => `${BASE_API_PATH}/Competition/Get?Id=${id}`,
    GetAdmin: (id) => `${BASE_API_PATH}/Competition/GetAdmin?Id=${id}`,
    GetAll: `${BASE_API_PATH}/Competition/GetAll`,
    GetAllAdmin: `${BASE_API_PATH}/Competition/GetAllAdmin`,
    GetMyCompetitions: `${BASE_API_PATH}/Competition/GetMyCompetitions`,
    GetActiveCompetitions: `${BASE_API_PATH}/Competition/GetAvailableCompetitions`,
    Update: (id) => `${BASE_API_PATH}/Competition/Update?Id=${id}`,
    Delete: (id) => `${BASE_API_PATH}/Competition/Delete?Id=${id}`,
  },

  // Organization
  //----------------------------------------------------------------------
  Organization: {
    Create: `${BASE_API_PATH}/Organization/Create`,
    Get: (id) => `${BASE_API_PATH}/Organization/Get?Id=${id}`,
    GetAll: `${BASE_API_PATH}/Organization/GetAll`,
    GetAllDropdown: `${BASE_API_PATH}/Organization/GetAllDropdown`,
    Update: (id) => `${BASE_API_PATH}/Organization/Update?Id=${id}`,
    UpdateImage: (id) => `${BASE_API_PATH}/Organization/UpdateImage?OrganizationId=${id}`,
    Delete: (id) => `${BASE_API_PATH}/Organization/Delete?Id=${id}`,
    DeleteImage: (id) => `${BASE_API_PATH}/Organization/DeleteImage?OrganizationId=${id}`,
    GetAffiliatedFairs: `${BASE_API_PATH}/Organization/GetAffiliatedFairs`,
  },

  // Participant
  //----------------------------------------------------------------------
  Participant: {
    Create: `${BASE_API_PATH}/Participant/Create`,
    CreateCompetitionParticipantFile: `${BASE_API_PATH}/Participant/CreateCompetitionParticipantFile`,
    Get: (id) => `${BASE_API_PATH}/Participant/Get?Id=${id}`,
    GetAll: `${BASE_API_PATH}/Participant/GetAll`,
    GetActives: `${BASE_API_PATH}/Participant/GetActives`,
    ApproveParticipant: `${BASE_API_PATH}/Participant/ApproveParticipant`,
    RejectParticipant: `${BASE_API_PATH}/Participant/RejectParticipant`,
    GetAllTeachers: `${BASE_API_PATH}/Participant/GetAllTeachers`,
    GetSupervisorByEmail: `${BASE_API_PATH}/Participant/GetSupervisorByEmail`,
    GetStudentByEmail: `${BASE_API_PATH}/Participant/GetStudentByEmail`,
    Update: (id) => `${BASE_API_PATH}/Participant/Update?Id=${id}`,
    UpdatePreferences: (id) => `${BASE_API_PATH}/Participant/UpdatePreferences?Id=${id}`,
    UpdateEmail: (id, email) =>
      `${BASE_API_PATH}/Participant/UpdateEmail?Id=${id}&Email=${encodeURIComponent(email)}`,
    Delete: (id) => `${BASE_API_PATH}/Participant/Delete?Id=${id}`,
  },

  // Participant Badges
  //----------------------------------------------------------------------
  ParticipantBadges: {
    GetAll: `${BASE_API_PATH}/Printable/GetParticipantInformations`,
    GetAllJudges: `${BASE_API_PATH}/Printable/GetJudgeInformations`,
    GetProjectInformations: `${BASE_API_PATH}/Printable/GetProjectInformations`,
    GetBadgeInfoPdf: `${BASE_API_PATH}/Printable/GetBadgeInfoPdf`,
    GetParticipantBadgesPdf: `${BASE_API_PATH}/Printable/GetParticipantBadgesPdf`,
    GetProjectBannersPdf: `${BASE_API_PATH}/Printable/GetProjectBannersPdf`,
    Get: (id) => `${BASE_API_PATH}/ParticipantBadges/Get?Id=${id}`,
    GenerateBadge: `${BASE_API_PATH}/ParticipantBadges/GenerateBadge`,
    PrintBadge: `${BASE_API_PATH}/ParticipantBadges/PrintBadge`,
    ConfirmAttendance: `${BASE_API_PATH}/ParticipantBadges/ConfirmAttendance`,
    CheckIn: `${BASE_API_PATH}/ParticipantBadges/CheckIn`,
    BulkGenerateBadges: `${BASE_API_PATH}/ParticipantBadges/BulkGenerateBadges`,
    Update: (id) => `${BASE_API_PATH}/ParticipantBadges/Update?Id=${id}`,
  },

  // Project Board Banner
  //----------------------------------------------------------------------
  ProjectBoardBanner: {
    GetProjectInformations: `${BASE_API_PATH}/Printable/GetProjectInformations`,
    GetProjectBannersPdf: `${BASE_API_PATH}/Printable/GetProjectBannersPdf`,
  },

  // Consent Form
  //----------------------------------------------------------------------
  ConsentForm: {
    GetAll: `${BASE_API_PATH}/Printable/GetProjectConsentInformations`,
  },

  // Participant Certificates
  //----------------------------------------------------------------------
  ParticipantCertificates: {
    GetAll: (competitionId) =>`${BASE_API_PATH}/Printable/GetParticipantCertificates${competitionId ? `?competitionId=${competitionId}` : ""}`,
    GetCertificateById: (certificateId) =>
      `${BASE_API_PATH}/Printable/GetParticipantCertificateById?CertificateId=${encodeURIComponent(certificateId)}`,
    GetCertificatesById: (certificateIds) =>
      `${BASE_API_PATH}/Printable/GetParticipantCertificatesById?${certificateIds.map((id) => `CertificateIds=${encodeURIComponent(id)}`).join('&')}`,
  },

  // Competition Certificates
  //----------------------------------------------------------------------
  CompetitionCertificates: {
    GetAll: (competitionId) =>`${BASE_API_PATH}/Printable/GetCompetitionCertificates${competitionId ? `?competitionId=${competitionId}` : ""}`,
    GetCertificateById: (certificateId) =>
      `${BASE_API_PATH}/Printable/GetCompetitionCertificateById?CertificateId=${encodeURIComponent(certificateId)}`,
  },

  // Project Awards
  //----------------------------------------------------------------------
  ProjectAwards: {
        GetAll: (competitionId) =>`${BASE_API_PATH}/Printable/GetProjectAwards${competitionId ? `?competitionId=${competitionId}` : ""}`
  },

  // Payment
  //----------------------------------------------------------------------
  Payment: {
    GetPayments: `${BASE_API_PATH}/Payment/GetProjectPayments`,
    GetTeacherPayments: `${BASE_API_PATH}/Payment/GetTeacherPayments`,
    GetParticipantPayments: `${BASE_API_PATH}/Payment/GetParticipantPayments`,
    GetPaymentsByParticipantPaymentId: `${BASE_API_PATH}/Payment/GetPaymentsByParticipantPaymentId`,
    GetReceipt: (paymentIntentId) =>
      `${BASE_API_PATH}/Payment/GetReceipt?PaymentIntentId=${paymentIntentId}`,
    ApprovePayment: `${BASE_API_PATH}/Payment/ApprovePayment`,
    RejectPayment: `${BASE_API_PATH}/Payment/RejectPayment`,
    CreatePaymentDocument: `${BASE_API_PATH}/Payment/CreatePaymentDocument`,
    GetUnapprovedPayments: `${BASE_API_PATH}/Payment/GetUnapprovedPayments`,
    GetPaymentSession: `${BASE_API_PATH}/Payment/GetPaymentSession`,
    DeferPayment: `${BASE_API_PATH}/Payment/DeferPayment`,
    Success: `${BASE_API_PATH}/Payment/success`,
    Failed: `${BASE_API_PATH}/Payment/failed`,
  },

  // Project
  //----------------------------------------------------------------------
  Project: {
    Create: `${BASE_API_PATH}/Project/Create`,
    CreateProjectFile: (projectId) =>
      `${BASE_API_PATH}/Project/CreateProjectFile?ProjectId=${projectId}`,
    DeleteProjectFile: (projectFileId) =>
      `${BASE_API_PATH}/Project/DeleteProjectFile?ProjectFileId=${projectFileId}`,
    SetProjectAsFinalist: (id) => `${BASE_API_PATH}/Project/SetProjectAsFinalist?Id=${id}`,
    SetProjectAsRegistered: (id) => `${BASE_API_PATH}/Project/SetProjectAsRegistered?Id=${id}`,
    SetProjectAsRejected: (id) => `${BASE_API_PATH}/Project/SetProjectAsRejected?Id=${id}`,
    UpdateSummary: `${BASE_API_PATH}/Project/UpdateSummary`,
    UpdateAbstract: (projectId) => `${BASE_API_PATH}/Project/UpdateAbstract?ProjectId=${projectId}`,
    UpdateThumbnail: (projectId) =>
      `${BASE_API_PATH}/Project/UpdateThumbnail?ProjectId=${projectId}`,
    GetSummary: (id) => `${BASE_API_PATH}/Project/GetSummary?Id=${id}`,
    GetConsentTerms: (projectId) =>
      `${BASE_API_PATH}/Project/GetConsentTerms?ProjectId=${projectId}`,
    GetConsentForm: (projectId) => `${BASE_API_PATH}/Project/GetConsentForm?ProjectId=${projectId}`,
    UpdateConsent: `${BASE_API_PATH}/Project/UpdateConsent`,
    Get: (id) => `${BASE_API_PATH}/Project/Get?Id=${id}`,
    GetAll: `${BASE_API_PATH}/Project/GetAll`,
    GetAllProjectConsents: `${BASE_API_PATH}/Project/GetProjectConsents`,
    Update: (id) => `${BASE_API_PATH}/Project/Update?Id=${id}`,
    Delete: (id) => `${BASE_API_PATH}/Project/Delete?Id=${id}`,
  },

  // Project Evaluation
  //----------------------------------------------------------------------
  JudgementEvaluation: {
    Create: `${BASE_API_PATH}/JudgementEvaluation/Create`,
    GetProject: (id) => `${BASE_API_PATH}/JudgementEvaluation/GetProject?Id=${id}`,
    UpdateOverAllComment: (id) => `${BASE_API_PATH}/JudgementEvaluation/UpdateOverAllComment`,
    GetAllProjects: `${BASE_API_PATH}/JudgementEvaluation/GetAllProjects`,
    Update: (id) => `${BASE_API_PATH}/JudgementEvaluation/Update?Id=${id}`,
  },

  // Judging Session
  //----------------------------------------------------------------------
  JudgingSession: {
    Create: `${BASE_API_PATH}/JudgementSession/Create`,
    GetAll: `${BASE_API_PATH}/JudgementSession/GetAll`,
    Get: (id) => `${BASE_API_PATH}/JudgementSession/Get?Id=${id}`,
    GetAllAvailableProjects: (judgementSessionId) =>
      `${BASE_API_PATH}/JudgementSession/GetAllAvailableProjects?JudgementSessionId=${judgementSessionId}`,
    GetAllAvailableJudges: (judgementSessionId) =>
      `${BASE_API_PATH}/JudgementSession/GetAllAvailableJudges?JudgementSessionId=${judgementSessionId}`,
    GetJudgementSessionProjectEvaluationForm: (id) =>
      `${BASE_API_PATH}/JudgementSession/GetJudgementSessionProjectEvaluationForm?Id=${id}`,
    Update: (id) => `${BASE_API_PATH}/JudgementSession/Update?Id=${id}`,
    Delete: (id) => `${BASE_API_PATH}/JudgementSession/Delete?Id=${id}`,
    AssignJury: `${BASE_API_PATH}/JudgementSession/AssignJuryToSession`,
    RemoveJury: `${BASE_API_PATH}/JudgementSession/RemoveJuryFromSession`,
    AssignProject: `${BASE_API_PATH}/JudgementSession/AssignProjectToSession`,
    RemoveProject: `${BASE_API_PATH}/JudgementSession/RemoveProjectFromSession`,
    UpdateProjectJudgementTime: `${BASE_API_PATH}/JudgementSession/UpdateProjectJudgementTime`,
    SetProjectAbsent: (projectId) => `${BASE_API_PATH}/JudgementSession/SetProjectAbsent?ProjectId=${projectId}`,
  },

  // System
  //----------------------------------------------------------------------
  System: {
    GetGroupRole: (groupId, roleId) =>
      `${BASE_API_PATH}/System/GetGroupRole?GroupId=${groupId}&RoleId=${roleId}`,
  },

  // Temp
  //----------------------------------------------------------------------
  Temp: {
    GetCountries: `${BASE_API_PATH}/Temp/GetCountries`,
    GetCategories: `${BASE_API_PATH}/Temp/GetCategories`,
    GetJudgementPeriods: `${BASE_API_PATH}/Temp/GetJudgementPeriods`,
    GetJudgementSessions: `${BASE_API_PATH}/Temp/GetJudgementSessions`,
    GetFairs: `${BASE_API_PATH}/Temp/GetFairs`,
  },

  // Venue
  //----------------------------------------------------------------------
  Venue: {
    GetAll: `${BASE_API_PATH}/Venue/GetAll`,
  },

  // User
  //----------------------------------------------------------------------

  User: {
    Create: `${BASE_API_PATH}/User/Create`,
    GetAll: `${BASE_API_PATH}/User/GetAll`,
    GetById: (id) => `${BASE_API_PATH}/User/GetById?Id=${id}`,
    GetStudents: (organizationId) =>
      `${BASE_API_PATH}/User/GetStudents?OrganizationId=${organizationId}`,
    GetTeachers: (organizationId) =>
      `${BASE_API_PATH}/User/GetTeachers?OrganizationId=${organizationId}`,
    Update: (id) => `${BASE_API_PATH}/User/Update?UserId=${id}`,
    UpdateSelfUser: (id) => `${BASE_API_PATH}/User/UpdateSelfUser`,
    SendVerificationMail: (userId) => `${BASE_API_PATH}/User/SendVerificationMail?UserId=${userId}`,
    SendResetPasswordEmail: (userId) =>
      `${BASE_API_PATH}/User/SendResetPasswordEmail?UserId=${userId}`,
    Delete: (id) => `${BASE_API_PATH}/User/Delete?Id=${id}`,
  },

  // Jury
  //----------------------------------------------------------------------

  Jury: {
    Create: `${BASE_API_PATH}/Jury/Create`,
    Approve: (id) => `${BASE_API_PATH}/Jury/ApproveJury?Id=${id}`,
    Reject: (id) => `${BASE_API_PATH}/Jury/RejectJury?Id=${id}`,
    DeleteJuryRegistration: (id) => `${BASE_API_PATH}/Jury/DeleteJuryRegistration?Id=${id}`,
    Get: (id) => `${BASE_API_PATH}/Jury/Get?Id=${id}`,
    GetActives: `${BASE_API_PATH}/Jury/GetActives`,
    GetAll: `${BASE_API_PATH}/Jury/GetAll`,
    GetAllDropdown: `${BASE_API_PATH}/Jury/GetAllDropdown`,
    GetAllApproved: `${BASE_API_PATH}/Jury/GetAllApproved`,
    GetAllUnapproved: `${BASE_API_PATH}/Jury/GetAllUnapproved`,
    GetJudgeEmailTemplates: (name) => `${BASE_API_PATH}/Jury/GetJudgeEmailTemplates?Name=${name}`,
    GetJudgeRejectEmailTemplates: (name) => `${BASE_API_PATH}/Jury/GetJudgeRejectEmailTemplates?Name=${name}`,
    Update: (id) => `${BASE_API_PATH}/Jury/Update?Id=${id}`,
    Delete: (id) => `${BASE_API_PATH}/Jury/Delete?Id=${id}`,
    SendJudgeMail: `${BASE_API_PATH}/Jury/SendJudgeMail`,
    UpdateSelfJuryAvailabilities: `${BASE_API_PATH}/Jury/UpdateSelfJuryAvailabilities`,
    GetSelfJuryAvailabilities: `${BASE_API_PATH}/Jury/GetSelfJuryAvailabilities`,
  },

  // Fair
  //----------------------------------------------------------------------

  Fair: {
    Approve: `${BASE_API_PATH}/Fair/Approve`,
    Create: `${BASE_API_PATH}/Fair/Create`,
    Get: (id) => `${BASE_API_PATH}/Fair/Get?Id=${id}`,
    GetAll: `${BASE_API_PATH}/Fair/GetAll`,
    GetAllDropdown: `${BASE_API_PATH}/Fair/GetAllDropdown`,
    Update: (id) => `${BASE_API_PATH}/Fair/Update?Id=${id}`,
    UpdateImage: (id) => `${BASE_API_PATH}/Fair/UpdateImage?FairId=${id}`,
    Delete: (id) => `${BASE_API_PATH}/Fair/Delete?Id=${id}`,
    DeleteImage: (id) => `${BASE_API_PATH}/Fair/DeleteImage?FairId=${id}`,
  },

  // Feedback
  //----------------------------------------------------------------------

  Feedback: {
    Submit: `${BASE_API_PATH}/Feedback/Submit`,
    Reply: (id) => `${BASE_API_PATH}/Feedback/Reply?Id=${id}`,
    Close: (id) => `${BASE_API_PATH}/Feedback/Close?Id=${id}`,
    GetAll: `${BASE_API_PATH}/Feedback/GetAll`,
    Delete: (id) => `${BASE_API_PATH}/Feedback/Delete?Id=${id}`,
  },

  // SurveyResponse
  //----------------------------------------------------------------------

  SurveyResponse: {
    Create: `${BASE_API_PATH}/SurveyResponse/Create`,
    GetAll: `${BASE_API_PATH}/SurveyResponse/GetAll`,
    Get: (id) => `${BASE_API_PATH}/SurveyResponse/Get?Id=${id}`,
    Delete: (id) => `${BASE_API_PATH}/SurveyResponse/Delete?Id=${id}`,
  },

  // Finalist
  //----------------------------------------------------------------------

  Finalist: {
    UploadFaceImage: (id) => `${BASE_API_PATH}/Finalist/UploadFaceImage?FinalistId=${id}`,
    UploadPassport: (id) => `${BASE_API_PATH}/Finalist/UploadPassport?FinalistId=${id}`,
    UploadVisa: (id) => `${BASE_API_PATH}/Finalist/UploadVisa?FinalistId=${id}`,
    Get: (id) => `${BASE_API_PATH}/Finalist/Get?Id=${id}`,
    GetAll: `${BASE_API_PATH}/Finalist/GetAll`,
    GetAllDistinct: `${BASE_API_PATH}/Finalist/GetAllDistinct`,
    Update: (id) => `${BASE_API_PATH}/Finalist/Update?Id=${id}`,
    UpdateHealthInformation: (id) => `${BASE_API_PATH}/Finalist/UpdateHealthInformation?Id=${id}`,
    UpdatePassportVisaInformation: (id) =>
      `${BASE_API_PATH}/Finalist/UpdatePassportVisaInformation?Id=${id}`,
    UpdatePerformanceInformation: (id) =>
      `${BASE_API_PATH}/Finalist/UpdatePerformanceInformation?Id=${id}`,
    UpdateTravelInformation: (id) => `${BASE_API_PATH}/Finalist/UpdateTravelInformation?Id=${id}`,
  },

  // Travel
  //----------------------------------------------------------------------

  Travel: {
    Get: (id) => `${BASE_API_PATH}/Travel/Get?Id=${id}`,
    GetAll: `${BASE_API_PATH}/Travel/GetAll`,
    Create: `${BASE_API_PATH}/Travel/Create`,
    Update: (id) => `${BASE_API_PATH}/Travel/Update?Id=${id}`,
    Delete: (id) => `${BASE_API_PATH}/Travel/Delete?Id=${id}`,
    AddParticipant: (travelId) => `${BASE_API_PATH}/Travel/AddParticipant?TravelId=${travelId}`,
    RemoveParticipant: (travelId, participantId) =>
      `${BASE_API_PATH}/Travel/RemoveParticipant?TravelId=${travelId}&ParticipantId=${participantId}`,
  },

  // Tour
  //----------------------------------------------------------------------

  Tour: {
    Get: (id) => `${BASE_API_PATH}/Tour/Get?Id=${id}`,
    GetAll: `${BASE_API_PATH}/Tour/GetAll`,
    Create: `${BASE_API_PATH}/Tour/Create`,
    Update: (id) => `${BASE_API_PATH}/Tour/Update?Id=${id}`,
    Delete: (id) => `${BASE_API_PATH}/Tour/Delete?Id=${id}`,
    CreateTourFile: (tourId) => `${BASE_API_PATH}/Tour/CreateTourFile?TourId=${tourId}`,
    DeleteTourFile: (tourDocumentId) =>
      `${BASE_API_PATH}/Tour/DeleteTourFile?TourDocumentId=${tourDocumentId}`,
    GetTourDocument: (id) => `${BASE_API_PATH}/Tour/GetTourDocument?Id=${id}`,
  },

  // Performance
  //----------------------------------------------------------------------

  Performance: {
    GetAll: `${BASE_API_PATH}/Performance/GetAll`,
  },

  // Document
  //----------------------------------------------------------------------

  Document: {
    Create: `${BASE_API_PATH}/Document/Create`,
    Get: (id) => `${BASE_API_PATH}/Document/Get?Id=${id}`,
    GetMultipleByIds: `${BASE_API_PATH}/Document/GetMultipleByIds`,
    GetAll: `${BASE_API_PATH}/Document/GetAll`,
    Delete: (id) => `${BASE_API_PATH}/Document/Delete?Id=${id}`,
  },

  // VIP
  //----------------------------------------------------------------------

  VipParticipant: {
    Create: (participantId) =>
      `${BASE_API_PATH}/VipParticipant/Create?ParticipantId=${participantId}`,
    Get: (id) => `${BASE_API_PATH}/VipParticipant/Get?Id=${id}`,
    GetAll: `${BASE_API_PATH}/VipParticipant/GetAll`,
    Update: (id) => `${BASE_API_PATH}/VipParticipant/Update?Id=${id}`,
    Delete: (id) => `${BASE_API_PATH}/VipParticipant/Delete?Id=${id}`,
  },

  // Report
  //----------------------------------------------------------------------

  Report: {
    Affiliates: `${BASE_API_PATH}/Report/Affiliates`,
    CurrentFunds: `${BASE_API_PATH}/Report/CurrentFunds`,
    Projects: `${BASE_API_PATH}/Report/Projects`,
    Judges: `${BASE_API_PATH}/Report/Judges`,
    Students: `${BASE_API_PATH}/Report/Students`,
    Supervisors: `${BASE_API_PATH}/Report/Supervisors`,
    Parents: `${BASE_API_PATH}/Report/Parents`,
    Guests: `${BASE_API_PATH}/Report/Guests`,
    Observers: `${BASE_API_PATH}/Report/Observers`,
    Relatives: `${BASE_API_PATH}/Report/Relatives`,
  },

  // Mailing
  //----------------------------------------------------------------------

  Mailing: {
    SendEmail: `${BASE_API_PATH}/Mailing/SendEmail`,
  },

  // Home Guideline
  //----------------------------------------------------------------------

  Home: {
    GuidelineInformations: `${BASE_API_PATH}/Home/GuidelineInformations`,
  },

  // Invitation Letter
  //----------------------------------------------------------------------

  InvitationLetter: {
    GetFinalistLetter: (projectId) =>
      `${BASE_API_PATH}/InvitationLetter/GetFinalistLetter?ProjectId=${projectId}`,
    GetFinalistLetterList: `${BASE_API_PATH}/InvitationLetter/GetFinalistLetterList`,
    SendFinalistLetter: (projectId) =>
      `${BASE_API_PATH}/InvitationLetter/SendFinalistLetter?ProjectId=${projectId}`,
    GetInvitationLetterList: `${BASE_API_PATH}/InvitationLetter/GetInvitationLetterList`,
    GetInvitationLetter: (projectId) =>
      `${BASE_API_PATH}/InvitationLetter/GetInvitationLetter?ProjectId=${projectId}`,
    GetVisaInvitationLetterList: `${BASE_API_PATH}/InvitationLetter/GetVisaInvitationLetterList`,
    GetVisaInvitationLetter: (projectId, participantId = null) => {
      let url = `${BASE_API_PATH}/InvitationLetter/GetVisaInvitationLetter?ProjectId=${projectId}`;
      if (participantId) {
        url += `&ParticipantId=${participantId}`;
      }
      return url;
    },
  },

  // Logger
  //----------------------------------------------------------------------

  Logger: {
    GetAll: `${BASE_API_PATH}/Log/GetAll`,
  },

  // User Action Type
  //----------------------------------------------------------------------

  UserActionType: {
    GetAll: `${BASE_API_PATH}/UserActionType/GetAll`,
  },

  // User Action
  //----------------------------------------------------------------------

  UserAction: {
    GetAll: `${BASE_API_PATH}/UserAction/GetAll`,
  },

  // Judging Evaluation Overview
  //----------------------------------------------------------------------

  JudgingEvaluationOverview: {
    GetProjectEvaluationOverviewReport: (
      categoryId,
      currentPage,
      takeCount,
      skipCount,
      field = null,
      direction = null
    ) => {
      // Build base URL with required parameters - CategoryId starts with capital letter now
      let url = `${BASE_API_PATH}/JudgingEvaluationOverview/GetProjectEvaluationOverviewReport?CategoryId=${categoryId}&CurrentPage=${currentPage}&TakeCount=${takeCount}&SkipCount=${skipCount}`;

      // Add sorting parameters if provided - Field and Direction for server-side sorting
      if (field && direction) {
        url += `&Field=${field}&Direction=${direction}`;
      }

      return url;
    },
  },

  // Judging Evaluation Ranking
  //----------------------------------------------------------------------

  JudgingEvaluationRanking: {
    GetAllProjects: (
      categoryId,
      currentPage,
      takeCount,
      skipCount,
      field = null,
      direction = null
    ) => {
      let url = `${BASE_API_PATH}/JudgingEvaluationRanking/GetAllProjects?CategoryId=${categoryId}&CurrentPage=${currentPage}&TakeCount=${takeCount}&SkipCount=${skipCount}`;

      // Add sorting parameters if provided - Field and Direction for server-side sorting
      if (field && direction) {
        url += `&Field=${field}&Direction=${direction}`;
      }

      return url;
    },
    RankProject: `${BASE_API_PATH}/JudgingEvaluationRanking/RankProject`,
    DeleteProjectRanking: (projectRankingId) =>
      `${BASE_API_PATH}/JudgingEvaluationRanking/DeleteProjectRanking?ProjectRankingId=${projectRankingId}`,
  },
};
